// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19HGM","left":"styles_left__3eP80"};